// extracted by css-extract-rspack-plugin
export default {"fill-skills":"B9ENjU2___fill-skills","fillSkills":"B9ENjU2___fill-skills","fill-skills__button":"prQznrt___fill-skills__button","fillSkillsButton":"prQznrt___fill-skills__button"};